

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMemberSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.sepa = _fi.$SepaModel.instance({ id: 123 });
            $scope.callbacks = {
                sepaAccept: function sepaAccept() {
                    (0, _squid.$populate)($scope, {
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        return $scope.sepa.action('sepaAccept', {
                            data: {
                                bank: {
                                    id: $scope.sepa.bankId
                                }
                            },
                            success: function success() {
                                $scope.parentCallbacks.success($scope.sepa);
                            }
                        });
                    });
                }
            };
        }]
    };
});

_squid.$populate;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_fi.$SepaModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/directive.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/directive.js
// module chunks = 0